const UnknownUserMessage = 'unknown_user';
export default class UnknownUserError extends Error {
    constructor(message: string) {
        super(`${UnknownUserMessage}: ${message}`);
    }
}
